var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"time-counter"},[_c('span',[_vm._v(_vm._s(_vm.hours))]),_vm._v(":"),_c('span',[_vm._v(_vm._s(_vm.minutes))]),_vm._v(":"),(_vm.showSeconds)?_c('span',[_vm._v(_vm._s(_vm.seconds))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }